export default __webpack_public_path__ + "8f9b7e78129d7600f4ef3fcfc3d6fae5.png";